
export default {
  props: {
    discount: {
      type: Number,
      default: 0.0,
    },
    subtotal: {
      type: [String, Number],
      default: 0.0,
    },
    shippingMethod: {
      type: [Object, Boolean],
      default: false,
    },
    save: {
      type: Number,
      default: 0.0,
    },
    total: {
      type: Number,
      default: 0.0,
    },
    changeShippingLink: {
      type: Boolean,
      default: false,
    },
    shipping: {
      type: Number,
      default: 0.0,
    },
    canShowShippingLineWhileLoggedOut: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    shippingIsFree() {
      const parsedShippingCost = parseFloat(this?.shippingMethod?.shippingCost)
      return parsedShippingCost < 0.01 && parsedShippingCost >= 0
    },
    loggedIn() {
      return this.$auth.loggedIn
    },
    shippingCosts() {
      return this?.shippingMethod?.shippingCost ? this.shippingMethod.shippingCost : this.shipping
    },
    loggedOutSubtotalExceedsShippingThreshold() {
      return !this.loggedIn && parseFloat(this.subtotal) >= parseFloat(this.shippingMethod?.freeShippingAt)
    },
    showLoggedOutShippingLine() {
      return (
        this.canShowShippingLineWhileLoggedOut &&
        this.shippingMethod?.freeShippingAt !== null &&
        this.loggedOutSubtotalExceedsShippingThreshold
      )
    },
  },
}
